import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, DateDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { RecordCategory } from './members/records/RecordCategory.js';
export class EventNotificationDeadline extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * Events within this start and end date will need to be accepted before the deadline.
         */
        this.startDate = new Date();
        this.endDate = new Date();
        this.deadline = new Date();
        /**
         * If set, will automatically add a 'quick' action in the 'Start' tab of the dashboard.
         * e.g. "Dien je kampmeldingen voor paaskampen ten laatse in voor 1 maart"
         */
        this.reminderText = null;
        this.reminderTitle = null;
        /**
         * Show reminder from this date until the deadline.
         */
        this.reminderFrom = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, optional: true, defaultValue: () => uuidv4() })
], EventNotificationDeadline.prototype, "id", void 0);
__decorate([
    field({ decoder: DateDecoder })
], EventNotificationDeadline.prototype, "startDate", void 0);
__decorate([
    field({ decoder: DateDecoder })
], EventNotificationDeadline.prototype, "endDate", void 0);
__decorate([
    field({ decoder: DateDecoder })
], EventNotificationDeadline.prototype, "deadline", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], EventNotificationDeadline.prototype, "reminderText", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 367 })
], EventNotificationDeadline.prototype, "reminderTitle", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], EventNotificationDeadline.prototype, "reminderFrom", void 0);
export class EventNotificationType extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.eventTypeIds = [];
        /**
         * Title of this notification. E.g. "Kampmelding"
         */
        this.title = '';
        /**
         * Explanation about what this is.
         */
        this.description = '';
        /**
         * Button text to fill in this form. E.g. "Kampmelding indienen"
         */
        this.buttonTitle = '';
        /**
         * Descriptive text below the button to fill in the form. E.g. "Het indienen van een kampmelding is verplicht voor kampen."
         */
        this.buttonDescription = '';
        /**
         * List of deadlines
         */
        this.deadlines = [];
        /**
         * Questions to anwer. You can create multiple record categories to simulate multiple steps in the process.
         *
         * These are optional and can be an empty array.
         */
        this.recordCategories = [];
        /**
         * Who will receive email notifications apart from submitter and creator.
         */
        this.contactResponsibilityIds = [];
    }
}
__decorate([
    field({ decoder: StringDecoder, optional: true, defaultValue: () => uuidv4() })
], EventNotificationType.prototype, "id", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], EventNotificationType.prototype, "eventTypeIds", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EventNotificationType.prototype, "title", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EventNotificationType.prototype, "description", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EventNotificationType.prototype, "buttonTitle", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EventNotificationType.prototype, "buttonDescription", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(EventNotificationDeadline) })
], EventNotificationType.prototype, "deadlines", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(RecordCategory) })
], EventNotificationType.prototype, "recordCategories", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), version: 365 })
], EventNotificationType.prototype, "contactResponsibilityIds", void 0);
//# sourceMappingURL=EventNotificationType.js.map